import * as React from 'react'
import classNames from 'classnames'

import Modal from '../Modal'
import style from './style.scss'

type FloatWidth = 'floatWidthThird' | 'floatWidthHalf' | 'floatWidthFull'
type FloatPosition = 'floatLeft' | 'floatRight' | 'floatCenter'
type ModalPhotoProps = { alt: string; src: string; srcSet: string }

type Props = {
  children: string
  className?: string
  floatPosition?: FloatPosition
  floatWidth?: FloatWidth
  isFloat?: boolean
  isInline?: boolean
  modalText?: string
}

type State = {
  isModalOpen: boolean
  modalPhotoProps?: ModalPhotoProps
}

class TextBlock extends React.PureComponent<Props, State> {
  static defaultProps = {
    className: '',
    isFloat: false,
    isInline: false,
    modalText: undefined,
  }

  state: State = {
    isModalOpen: false,
    modalPhotoProps: undefined,
  }

  handleClick = (
    event:
      | React.MouseEvent<HTMLImageElement>
      | React.MouseEvent<HTMLSpanElement>,
  ) => {
    const { modalText } = this.props

    if (event.target instanceof HTMLImageElement) {
      const { dataset } = event.target

      if (dataset && dataset.isModal) {
        const { src, srcset: srcSet, alt } = event.target

        this.setState({
          isModalOpen: true,
          modalPhotoProps: { src, srcSet, alt },
        })
      }
    }

    if (modalText && event.target instanceof HTMLSpanElement) {
      const { dataset } = event.target

      // Prevents external actions from firing on modal trigger for Input elements.
      event.preventDefault()

      if (dataset && dataset.isModal) {
        this.setState({ isModalOpen: true })
      }
    }
  }

  handleCloseModal = () => {
    this.setState({ isModalOpen: false, modalPhotoProps: undefined })
  }

  render() {
    const {
      className,
      children,
      floatPosition,
      floatWidth,
      isFloat,
      isInline,
      modalText,
    } = this.props
    const { modalPhotoProps, isModalOpen } = this.state

    const extraClassNames = { [style.callout]: isFloat }

    if (floatPosition) {
      extraClassNames[style[floatPosition]] = isFloat
    }

    if (floatWidth) {
      extraClassNames[style[floatWidth]] = isFloat
    }

    const updatedProps = {
      dangerouslySetInnerHTML: { __html: children },
      className: classNames(style.wrapper, extraClassNames, className),
      onClick: this.handleClick,
    }

    return (
      <>
        {isInline ? <span {...updatedProps} /> : <div {...updatedProps} />}
        {isModalOpen && modalPhotoProps && (
          <Modal>
            <div className={style.modal} onClick={this.handleCloseModal}>
              <i className={style.closeIcon} />
              <img {...modalPhotoProps} />
            </div>
          </Modal>
        )}
        {isModalOpen && modalText && (
          <Modal>
            <div className={style.modal} onClick={this.handleCloseModal}>
              <div
                className={style.modalText}
                onClick={(event) => event.stopPropagation()}
              >
                <i
                  className={style.closeIcon}
                  onClick={this.handleCloseModal}
                />
                <TextBlock>{modalText}</TextBlock>
              </div>
            </div>
          </Modal>
        )}
      </>
    )
  }
}

export default TextBlock
